import React from 'react';
import { object, number, string, boolean } from 'yup';
import { startCase } from 'lodash';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import { env } from '~/commons/config';

const defaults = {
  owner: '',
  target: '',
  targetModel: '',
  status: '',
  action: '',
  payload: '',
  dge: Number,
  gxe: Number,
  tx: '',
};
const schema = object({});

const FormPaymentRecord = ({ paymentRecord }) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: paymentRecord
        ? {
            ...paymentRecord,
            target: JSON.stringify(
              paymentRecord.target,
              null,
              2
            ),
            payload: JSON.stringify(
              paymentRecord.payload,
              null,
              2
            ),
          }
        : {},
      formStatus: { disabled: true },
      api: '/api/site/paymentRecords',
      // onSubmit: (v) => ({
      //   ...v,
      // }),
    }}>
    {({ values }) => {
      return (
        <>
          <FormGroup name="owner" />
          <FormGroup name="status" />
          <FormGroup name="action" />
          <div className="row">
            <div className="col">
              <FormGroup name="dge" />
            </div>
            <div className="col">
              <FormGroup name="gxe" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="target">tx</label>
            {!!paymentRecord.tx && <pre>{JSON.stringify(paymentRecord.tx, null, 2) || ''}</pre>}
          </div>
          <FormGroup name="targetModel" />
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label htmlFor="payload">Payload</label>
                <pre>{values.payload || ''}</pre>
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label htmlFor="target">Target</label>
                <pre>{values.target || ''}</pre>
              </div>
            </div>
          </div>
        </>
      );
    }}
  </FormResource>
);

export default FormPaymentRecord;
